(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ds-review-composer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ds-review-composer')) {
  customElements.define('ds-review-composer', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.labels = JSON.parse(this.querySelector('[data-composer-labels]').textContent);
      this.button = this.querySelector('button');
      this.button.addEventListener('click', () => this.open());
    }
    disconnectedCallback() { this.close(); }
    node(tag, cls, text) {
      const el = document.createElement(tag);
      if (cls) el.className = cls;
      if (text) el.textContent = text;
      return el;
    }
    async runtime() {
      for (let n = 0; n < 60 && !window.jdgm?.loadScript; n++) await new Promise(resolve => setTimeout(resolve, 200));
      if (window.jdgm?.loadScript && !window.jdgm.shopParams) {
        await new Promise((resolve, reject) => {
          const timer = setTimeout(() => reject(new Error('Judge.me core timeout')), 15000);
          window.jdgm.loadScript('widget/base.js', () => window.jdgm.loadScript('widget/common.js', () => { clearTimeout(timer); resolve(); }));
        });
      }
      for (let n = 0; n < 60; n++) {
        if (window.jdgm?.$ && window.jdgm?.shopParams) break;
        await new Promise(resolve => setTimeout(resolve, 200));
      }
      if (!window.jdgm?.$ || !window.jdgm?.shopParams) throw new Error('Judge.me core unavailable');
      const load = (url, ready) => {
        if (ready()) return Promise.resolve();
        return new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = url; script.async = true;
          const timer = setTimeout(() => { script.remove(); reject(new Error('Judge.me script timeout')); }, 15000);
          script.onload = async () => { for(let n=0;n<50&&!ready();n++) await new Promise(done=>setTimeout(done,100)); clearTimeout(timer); ready() ? resolve() : reject(new Error('Judge.me script unavailable')); };
          script.onerror = () => { clearTimeout(timer); script.remove(); reject(new Error('Judge.me network error')); };
          document.head.append(script);
        });
      };
      window.jdgm.loadCSS(window.jdgm.widgetPath('base.css'));
      window.jdgm.loadCSS(window.jdgm.widgetPath('form.css'));
      await load('https://cdn.judge.me/widget/form.js', () => !!window.jdgm.setupMediaUtil);
      await load('https://cdn.judge.me/widget/write_review_modal.js', () => !!window.jdgm._WriteReviewModal);
    }
    async open() {
      if (this.opening || this.modal || document.querySelector('.dsrw')) return;
      this.opening = true; this.button.disabled = true; this.button.textContent = this.labels.loading;
      this.querySelector('.dsrw__entry-error').hidden = true;
      try {
        await this.runtime();
        const native = new window.jdgm._WriteReviewModal(window.jdgm.$);
        this.native = native;
        await native.setup('jdgm-review-widget-modal', this.dataset.productId, { isLeavingShopReview: this.dataset.storeReview === 'true' });
        if (!this.isConnected) { native.$modal.remove(); return; }
        if (native.requireVerificationBeforeSubmit || native._compactMode || native.customQuestionsEnabled) {
          native.showModalPage();
          this.native = null;
          return;
        }
        this.mount(native);
      } catch (error) {
        console.warn('DinoSpirit review form:', error.message || 'unavailable');
        this.dataset.error = error.message || String(error);
        this.close(); this.native?.$modal?.remove(); this.native = null;
        const alert = this.querySelector('.dsrw__entry-error'); alert.textContent = this.labels.unavailable; alert.hidden = false;
      } finally { this.opening = false; this.button.disabled = false; this.button.textContent = this.labels.write; }
    }
    mount(native) {
      const root = native.$modal[0]; this.modal = root; root.classList.add('dsrw');
      const kinds = ['review-form-intro','share-media','review-details','about-you'];
      this.steps = kinds.map(kind => root.querySelector('.jdgm-write-review-modal__page--' + kind));
      if (this.steps.some(step => !step)) throw new Error('Unsupported Judge.me form structure');
      const content = root.querySelector('.jdgm-write-review-modal__content');
      const pages = this.node('div','dsrw__pages');
      this.steps.forEach((step, i) => { step.classList.add('dsrw__step'); step.dataset.step = i; pages.append(step); });
      this.success = this.node('div','dsrw__step dsrw__success');
      this.success.append(this.node('h2','dsrw__thanks',this.labels.thanks), this.node('p','',this.labels.submitted), this.node('p','dsrw__verification',this.labels.verification));
      const particles = this.node('div','dsrw__confetti'); particles.setAttribute('aria-hidden','true');
      for(let n=0;n<18;n++){const dot=this.node('i');dot.style.setProperty('--i',n);particles.append(dot);}
      this.success.append(particles); pages.append(this.success);
      const close = this.node('button','dsrw__close','×'); close.type='button';close.setAttribute('aria-label',this.labels.close);close.onclick=()=>this.close();
      this.error = this.node('p','dsrw__error');this.error.setAttribute('role','alert');this.error.hidden=true;
      const footer=this.node('div','dsrw__footer');
      this.back=this.node('button','dsrw__back','← '+this.labels.back);this.back.type='button';this.back.onclick=()=>this.go(this.step-1);
      this.progress=this.node('div','dsrw__progress');this.progress.setAttribute('role','group');this.progress.setAttribute('aria-label',this.labels.steps);
      for(let n=0;n<4;n++)this.progress.append(this.node('span'));
      this.next=this.node('button','dsrw__next',this.labels.next);this.next.type='button';this.next.onclick=()=>this.advance();
      footer.append(this.back,this.progress,this.next);content.replaceChildren(close,pages,this.error,footer);
      native._closeModal=()=>this.close();
      native.showModalPage=page=>{if(page===native.pageNumbers.thankYou)this.go(4);};
      native._remountThankYouPage=()=>{};
      this.previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';
      root.querySelector('.jdgm-write-review-modal__overlay').onclick=()=>this.close();
      this.styleFields(native);
      this.uploadObserver=new MutationObserver(()=>this.mediaChanged());
      this.uploadObserver.observe(this.steps[1],{childList:true,subtree:true,attributes:true,attributeFilter:['class']});
      this.steps[1].querySelector('input[type=file]').addEventListener('change',()=>{this.autoAdvanceMedia=true;setTimeout(()=>this.mediaChanged(),0);});
      native.$starsFormIntro.off('click.writeReviewModal').on('click.dsrw',(event)=>{
        const rating=Number(event.currentTarget.dataset.alt);
        if(rating<1||rating>5)return;
        native.rating=rating;
        native.$starsReviewDetails.closest('.jdgm-write-review-modal__stars').find('.jdgm-star[data-alt="'+rating+'"]').click();
        clearTimeout(this.starTimer);this.starTimer=setTimeout(()=>this.go(1),200);
      });
      root.style.display='block';native._lastFocusedElement=this.button;
      native._setupKeyboardAccessibility();this.go(0);
    }
    styleFields(native) {
      const [rating,media,body,about]=this.steps;
      rating.querySelector('.jdgm-write-review-modal__title').textContent=this.dataset.storeReview==='true'?this.labels.store_rating:this.labels.rating;
      rating.querySelector('.jdgm-write-review-modal__intro')?.remove();
      rating.querySelectorAll('.jdgm-star').forEach(star=>{
        const svg=document.createElementNS('http://www.w3.org/2000/svg','svg');
        svg.setAttribute('viewBox','0 0 24 24');svg.setAttribute('aria-hidden','true');svg.setAttribute('focusable','false');
        const path=document.createElementNS('http://www.w3.org/2000/svg','path');
        path.setAttribute('d','M12 2.5 14.9 8.4 21.4 9.3 16.7 13.9 17.8 20.4 12 17.3 6.2 20.4 7.3 13.9 2.6 9.3 9.1 8.4Z');
        svg.append(path);star.replaceChildren(svg);star.type='button';
      });
      const hints=this.node('div','dsrw__star-hints');hints.append(this.node('span','',this.labels.dislike),this.node('span','',this.labels.love));rating.querySelector('.jdgm-write-review-modal__stars').after(hints);
      media.querySelector('.jdgm-write-review-modal__title').textContent=this.labels.media;
      media.querySelector('.jdgm-write-review-modal__intro').textContent=this.labels.media_intro;
      const reward=this.node('div','dsrw__reward');reward.append(this.node('strong','',this.labels.reward));media.querySelector('.jdgm-write-review-modal__field-group--media-upload').prepend(reward);
      media.querySelector('.jdgm-write-review-modal__media-upload-prompt').textContent=this.labels.add_media;
      media.querySelector('input[type=file]').setAttribute('aria-label',this.labels.add_media);
      body.querySelector('.jdgm-write-review-modal__page-header').prepend(this.node('h2','jdgm-write-review-modal__title',this.labels.body));
      native.$reviewBodyInput.attr('placeholder',this.labels.body_placeholder);
      body.querySelector('.jdgm-write-review-modal__intro')?.remove();
      about.querySelector('.jdgm-write-review-modal__title').textContent=this.labels.about;
      about.querySelector('.jdgm-write-review-modal__intro')?.remove();
      const nativeName=native.$nameInput[0];const field=nativeName.closest('.jdgm-write-review-modal__field-group');field.classList.add('dsrw__native-name');
      const row=this.node('div','dsrw__names');
      const make=(key,required)=>{const label=this.node('label','',this.labels[key]+(required?' *':''));const input=this.node('input');input.type='text';input.autocomplete=key==='first'?'given-name':'family-name';input.maxLength=100;input.required=required;label.append(input);row.append(label);return input;};
      this.first=make('first',true);this.last=make('last',false);
      const oldName=nativeName.value.trim().split(/\s+/);this.first.value=oldName.shift()||'';this.last.value=oldName.join(' ');
      const email=native.$emailInput[0];email.closest('.jdgm-write-review-modal__field-group')?.before(row);
      if(!row.isConnected)field.before(row);
      this.first.oninput=this.last.oninput=()=>{nativeName.value=[this.first.value.trim(),this.last.value.trim()].filter(Boolean).join(' ');native.$nameInput.data('manually-edited',true);};
      const label=about.querySelector('label[for="jdgm-email-input"]');if(label)label.textContent=this.labels.email+' *';
      const anonymous=about.querySelector('#jdgm-anonymous-checkbox');
      if(anonymous){anonymous.checked=false;anonymous.closest('.jdgm-write-review-modal__field-group')?.remove();}
      about.querySelectorAll('.jdgm-write-review-modal__field-help').forEach(el=>el.remove());
      const nativeTerms=body.querySelector('.jdgm-write-review-modal__gdpr-statement');if(nativeTerms)about.append(nativeTerms);
      about.addEventListener('input',()=>this.updateNext());body.addEventListener('input',()=>this.updateNext());
    }
    mediaState() {
      const page=this.steps[1];
      const count=(window.jdgm.addedImageKeys?.length||0)+(window.jdgm.addedVideoKeys?.length||0);
      return {count,uploading:!!page.querySelector('.jdgm-is-uploading,.jdgm-is-uploading-picture'),failed:!!page.querySelector('.jdgm-upload-error,.jdgm-media-upload-error')};
    }
    mediaChanged() {
      if(!this.modal)return;
      const state=this.mediaState();this.updateNext();
      if(this.step===1&&this.autoAdvanceMedia&&state.count&&!state.uploading&&!state.failed){this.autoAdvanceMedia=false;clearTimeout(this.mediaTimer);this.mediaTimer=setTimeout(()=>{if(this.step===1&&!this.mediaState().uploading)this.go(2);},450);}
    }
    updateNext() {
      if(!this.next||this.busy)return;
      this.next.disabled=this.step===2&&!this.native.$reviewBodyInput.val().trim();
      if(this.step===1){const media=this.mediaState();this.next.textContent=media.count?this.labels.continue:this.labels.skip;this.next.disabled=media.uploading;}
      else this.next.textContent=this.step===3?this.labels.done:this.step===4?this.labels.continue:this.labels.next;
    }
    go(step) {
      if(!this.modal||this.busy||step<0||step>4)return;
      this.step=step;this.error.hidden=true;
      [...this.steps,this.success].forEach((el,i)=>{el.hidden=i!==step;el.classList.toggle('current-page',i===step);});
      this.modal.dataset.step=step;
      this.modal.setAttribute('aria-label',step===4?this.labels.thanks:this.labels.write);
      this.back.hidden=step===0||step===4;this.next.hidden=step===0;this.progress.hidden=step===0||step===4;
      [...this.progress.children].forEach((el,i)=>el.classList.toggle('is-active',i<=step));
      this.updateNext();
      const current=step===4?this.success:this.steps[step];
      const heading=current.querySelector('[role=heading],h2');if(heading){heading.tabIndex=-1;heading.focus({preventScroll:true});}
    }
    async advance() {
      if(this.busy)return;
      if(this.step===4){this.close();return;}
      if(this.step===1){if(this.mediaState().uploading)return; if(!this.native._validateShareMediaPage())return;this.autoAdvanceMedia=false;this.go(2);return;}
      if(this.step===2){if(this.native._validateReviewDetailsPage())this.go(3);return;}
      if(this.step!==3)return;
      this.first.oninput();
      if(!this.first.value.trim()){this.first.reportValidity();return;}
      if(!this.native._validateAboutYouPage())return;
      if(this.mediaState().uploading){this.error.textContent=this.labels.wait_upload;this.error.hidden=false;return;}
      const native=this.native;
      if(native.isLeavingShopReview)native.storeReviewData={rating:native.rating,name:native.$nameInput.val(),email:native.$emailInput.val(),title:native.$reviewTitleInput.val()||'',body:native.$reviewBodyInput.val(),reviewer_name_format:native.$reviewerNameFormat.val()||''};
      if(native.isPreviewMode || window.jdgm.shopPreviews){this.error.textContent=this.labels.submit_error;this.error.hidden=false;return;}
      this.busy=true;this.next.disabled=true;this.back.disabled=true;this.next.textContent=this.labels.sending;
      try {
        await native._submitCompleteReview();
        this.busy=false;this.go(4);
        const gallery=this.closest('ds-review-gallery');gallery?.cache?.clear();
        try { for(let n=sessionStorage.length-1;n>=0;n--){const key=sessionStorage.key(n);if(key?.startsWith('dsr:v1:'))sessionStorage.removeItem(key);} } catch (_) {}
      }catch(error){this.busy=false;this.error.textContent=this.labels.submit_error;this.error.hidden=false;}
      finally{this.back.disabled=false;this.updateNext();}
    }
    close() {
      if(this.busy)return;
      if(this.modal&&this.steps&&this.mediaState().uploading){this.error.textContent=this.labels.wait_upload;this.error.hidden=false;return;}
      clearTimeout(this.starTimer);clearTimeout(this.mediaTimer);this.uploadObserver?.disconnect();
      if(this.modal){this.native?._teardownKeyboardAccessibility();window.jdgm.addedImageKeys=[];window.jdgm.addedVideoKeys=[];this.modal.remove();document.body.style.overflow=this.previousOverflow;this.modal=null;this.native=null;this.button?.focus({preventScroll:true});}
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["winchi-option-row"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('winchi-option-row')) {
  customElements.define('winchi-option-row', class extends HTMLElement {
    connectedCallback() {
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.fit());
      };
      this.mobile = matchMedia('(max-width: 767px)');
      this.mobile.addEventListener('change', this.schedule);
      this.resize = new ResizeObserver(this.schedule);
      this.resize.observe(this);
      this.changes = new MutationObserver(this.schedule);
      this.changes.observe(this.parentElement, {childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'hidden']});
      document.fonts.ready.then(() => { if (this.isConnected) this.schedule(); });
      this.schedule();
    }
    fit() {
      if (!this.clientWidth) return;
      const labels = Array.from(this.children).filter(el => el.matches('label.hdt-product-form_value') && getComputedStyle(el).display !== 'none');
      if (!labels.length) return;
      if (this.mobile.matches) {
      this.style.setProperty('--winchi-option-font', '16px');
      let textWidth = 0;
      let spacing = parseFloat(getComputedStyle(this).columnGap) * (labels.length - 1);
      labels.forEach(label => {
        const style = getComputedStyle(label);
        spacing += parseFloat(style.paddingLeft) + parseFloat(style.paddingRight) + parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);
        Array.from(label.childNodes).forEach(node => {
          if (node.nodeType !== Node.TEXT_NODE && (node.nodeType !== Node.ELEMENT_NODE || node.classList.contains('sr-only'))) return;
          const range = document.createRange();
          range.selectNodeContents(node);
          textWidth += range.getBoundingClientRect().width;
        });
      });
      const font = Math.min(16, Math.floor(16 * Math.max(1, this.clientWidth - spacing - labels.length) / Math.max(1, textWidth) * 100) / 100);
      this.style.setProperty('--winchi-option-font', `${font}px`);
      } else {
        this.style.removeProperty('--winchi-option-font');
      }
      if (this.parentElement.hasAttribute('data-winchi-garment')) {
        const selected = this.querySelector('input:checked');
        const label = labels.find(el => el.htmlFor === selected?.id);
        const heading = this.parentElement.querySelector('[update-value]');
        if (label && heading) {
          const display = Array.from(label.childNodes).filter(node => node.nodeType === Node.TEXT_NODE).map(node => node.textContent).join('').trim() || label.querySelector('.hdt-form-color-name')?.textContent.trim();
          if (display && heading.textContent !== display) heading.textContent = display;
        }
      }
    }
    disconnectedCallback() {
      this.mobile?.removeEventListener('change', this.schedule);
      this.resize?.disconnect();
      this.changes?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
